// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Button, Text, Icon } from 'primitive-components';
import { graphqlClient } from 'bk-web-app';
// $FlowFixMe - TS file
import env from 'bench-environment';
import { colors } from 'bench-style-constants';
import UPDATE_CURRENT_UI from './sidebar/mutations';

// Appcue Flow Id for the self-serve New UI transition walkthrough
const APPCUES_V2_TRANSITION_FLOW_ID = 'b24da62a-629d-4e83-8a05-629a1c596e4f';

const BannerContainer = styled.div`
  align-items: center;
  background: linear-gradient(270deg, #2052a4 0.01%, #6794e9 100%);
  display: flex;
  justify-content: center;
  padding: 24px;
  position: relative;
`;

const IllustrationBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(https://assets.bench.co/img/illustrations/UITransitions_banner.png) no-repeat;
  background-size: auto 132px;
  background-position: center;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  color: black;
`;

const SwitchIcon = styled(Icon)`
  fill: none;
  stroke: ${colors.black};
  margin-top: 5px;
`;

const BannerText = styled(Text)`
  padding-bottom: 15px;
  display: flex;
  align-items: center;
`;

const SwitchActions = styled.div`
  display: flex;
`;

const ActionButton = styled(Button)`
  margin: 0 10px;
  background: ${props => (props.emphasized ? colors.black : colors.white)};
  color: ${props => (props.emphasized ? colors.white : colors.black)};
  &:hover {
    background: ${props => (props.emphasized ? '#065b5c' : '#E0DEDA')};
    color: ${props => (props.emphasized ? colors.white : colors.black)};
  }
`;

const CloseButton = styled(Button)`
  border-radius: 50%;
  padding: 0;
  position: absolute;
  right: 10px;
  top: 10px;
  font-weight: 700;
  color: ${colors.white};
  background: transparent;
`;

type SwitchBannerProps = {
  clientId: string,
};

type SwitchBannerState = {
  isBannerVisible: boolean,
};

export default class SwitchBanner extends React.Component<SwitchBannerProps, SwitchBannerState> {
  constructor(props: SwitchBannerProps) {
    super(props);
    this.state = {
      isBannerVisible: !window.localStorage.getItem('isNewUISwitchBannerVisible'),
    };
  }

  switchToNewUi(client: string) {
    const mutation = UPDATE_CURRENT_UI;
    const variables = { clientId: client, unifiedBanking: true };
    return graphqlClient.mutate({ mutation, variables }).then(result => {
      if (result.data.selfServeUiSwitch) {
        window.localStorage.setItem('isNewUISwitchBannerVisible', false);
        return window.location.replace(`${env.location.cwa}/client/${variables.clientId}/welcome`);
      }
      return result;
    });
  }

  startNewUiWalkthrough() {
    window.Appcues.show(APPCUES_V2_TRANSITION_FLOW_ID);
  }

  handleHideBanner() {
    window.localStorage.setItem('isNewUISwitchBannerVisible', false);
    this.setState({ isBannerVisible: false });
  }

  render() {
    const { isBannerVisible } = this.state;

    return (
      isBannerVisible && (
        <BannerContainer>
          <IllustrationBackground />
          <ContentContainer>
            <BannerText>
              <SwitchIcon icon="responsiveDesign" /> Switch to the new Bench! Our platform will soon
              be updated with a new Bench experience.
            </BannerText>
            <SwitchActions>
              <ActionButton emphasized={false} onClick={() => this.startNewUiWalkthrough()}>
                Learn More
              </ActionButton>
              <ActionButton emphasized onClick={() => this.switchToNewUi(this.props.clientId)}>
                Switch Now
              </ActionButton>
            </SwitchActions>
          </ContentContainer>
          <CloseButton size="small" onClick={() => this.handleHideBanner()}>
            HIDE{' '}
          </CloseButton>
        </BannerContainer>
      )
    );
  }
}
